import BankitApp from '../assets/img/bankit-app.jpg'
import BankitWeb from '../assets/img/bankit-website.jpg'
import CountryStats from '../assets/img/country-states.jpg'
import FenkoHotel from '../assets/img/fenko-hotel.jpg'
import Freelance from '../assets/img/freelance.jpg'
import Fresco from '../assets/img/fresco.jpg'
import GuessNumber from '../assets/img/guess-the-number-name.jpg'
import KardioDev from '../assets/img/kardio-dev-app.jpg'
import NexterHomes from '../assets/img/nexter-homes.jpg'
import PigGame from '../assets/img/the-pig-game.jpg'
import Tours from '../assets/img/tours.jpg'
import Wallee from '../assets/img/wallee.jpg'
import Bridges_Explorer_1 from '../assets/img/bridge-risk-explorer-1.png'
import Bridges_Explorer_2 from '../assets/img/bridge-risk-explorer-2.png'
import Bridges_Explorer_3 from '../assets/img/bridge-risk-explorer-3.png'
import Smarts_1 from '../assets/img/smarts_1.png'
import Smarts_3 from '../assets/img/smarts_3.png'
import Smarts_4 from '../assets/img/smarts_4.png'
import Smarts_6 from '../assets/img/smarts_6.png'
import Central_1 from '../assets/img/central_1.png'
import Central_2 from '../assets/img/central_2.png'
import Central_3 from '../assets/img/central_3.png'
import Central_5 from '../assets/img/central_5.png'
import Connect_ai_1 from '../assets/img/connect_ai_1.png'
import Connect_ai_4 from '../assets/img/connect_ai_4.png'
import Connect_ai_5 from '../assets/img/connect_ai_5.png'
import Gripss_1 from '../assets/img/gripss_1.png'
import Gripss_2 from '../assets/img/gripss_2.png'
import Gripss_3 from '../assets/img/gripss_3.png'
import Eda_1 from '../assets/img/eda_1.png'

// -------------------------------------------------------------------
/* TODO -> still need to add React apps 

    - Food order app 
    - expense tracker
    
*/
// -------------------------------------------------------------------

import Aahrpp from '../assets/img/aahrpp.jpg'
import Nceed from '../assets/img/nceed-eating-disorder.jpg'
import NlmDreamAnatomy_Prototype from '../assets/img/nlm-dream-anatomy-protoype.jpg'
import NlmDreamAnatomy from '../assets/img/nlm-dream-anatomy.jpg'

// NOTE: 'images' property can have nested 'overview, development, prototyping & challenges' properties just like 'details' property. And will show that image before its corresponding text.
// If any if the nested potteries inside 'details' property have empty stings, then they will not be rendered.

const worksData = [
    {
        id: 'bridge-risk-explorer',
        type: 'Full-Stack Geospatial Data Application',
        images: {
            overview: Bridges_Explorer_1,
            development: Bridges_Explorer_2,
            prototyping: Bridges_Explorer_3,
        },
        altText:
            'Bridge Risk Explorer dashboard showing National Bridge Inventory bridge risk data, map view, and inspection details.',
        title: 'Bridge Risk Explorer',
        role: 'Product Design / Full-Stack Development / Data Visualization',
        stack: 'Next.js / React / TypeScript / PostgreSQL / PostGIS / Prisma / Tailwind CSS / MapLibre / TanStack Query',
        overview:
            'Full-stack infrastructure risk exploration tool built on the National Bridge Inventory. The application helps users identify, prioritize, and inspect bridges through a synchronized dashboard, data grid, map view, risk hotspots, and details inspector.',

        details: {
            overview: `Bridge Risk Explorer is a full-stack geospatial application built to help infrastructure planners explore bridge condition and risk across the National Bridge Inventory.

The product combines a dashboard overview, high-performance bridge grid, interactive MapLibre map, risk hotspot summaries, and detailed bridge inspection panels. The goal was to turn a large, raw federal dataset into a focused decision-support workspace for identifying bridges that may require closer attention.`,

            development: `I built the application with Next.js, React, TypeScript, PostgreSQL, PostGIS, Prisma, Tailwind CSS, TanStack Query, and MapLibre.

The system includes a streaming import pipeline that reads FHWA/NBI delimited text files, normalizes raw bridge fields, converts NBI coordinate formats, derives bridge age and inspection dates, classifies bridge condition, and assigns transparent rule-based priority levels. Raw FHWA field names are isolated to the importer, while the database, API, and frontend use a clean flat Bridge domain model.

The frontend includes a dark, data-dense dashboard, synchronized explorer grid and map views, URL-backed filters, state/county filtering, risk hotspots, map marker interactions, and a details inspector that explains priority reasons and key bridge metadata.`,

            prototyping: `The project started with product and architecture planning before implementation. I focused on keeping the scope narrow but polished: dashboard overview, explorer grid, map, filters, hotspots, and details inspection.

I used AI tools to accelerate implementation in small reviewable phases, while making the product and architecture decisions myself. Key design decisions included a flat domain model, a dedicated importer boundary, purpose-built API DTOs, national-safe map queries, cached dashboard summaries, and transparent priority rules instead of an arbitrary risk score.`,

            challenges: `The largest challenge was turning a large, messy FHWA/NBI text dataset into a responsive product experience.

This required building a streaming CSV import pipeline instead of loading the full file into memory, normalizing inconsistent text and date formats, converting NBI latitude and longitude values into decimal coordinates, and generating state/county lookup data from official reference files.

Another challenge was keeping the application fast on a national dataset. I added database indexes, bounded map queries, marker limits, cached dashboard summaries, and Supabase/Vercel deployment configuration using the transaction pooler to avoid serverless connection issues.`,
        },

        url: 'https://bridge-explorer-nine.vercel.app/dashboard',
        github: 'https://github.com/BigMikeL9/bridge-explorer',
    },
    {
        id: 'smarts-reportbuilder',
        type: 'Internal Reporting Platform (Cross-Platform Desktop Application)',
        images: {
            overview: Smarts_1,
            development: Smarts_3,
            prototyping: Smarts_4,
            challenges: Smarts_6,
        },
        altText:
            'SMARTS ReportBuilder platform used for generating dynamic engineering inspection reports.',
        title: 'SMARTS ReportBuilder',
        role: 'System Design / Full-Stack Development',
        stack: 'C# / .NET / MAUI / Blazor / React / REST APIs / SQLite',
        overview:
            'Internal reporting platform for generating structured engineering reports through configurable templates. Includes a cross-platform desktop application with an embedded local database for offline use, plus a web administration platform for managing templates and submissions.',

        details: {
            overview: `SMARTS ReportBuilder is an internal platform built to allow engineers to generate structured technical reports through configurable templates rather than hardcoded forms. The system supports both online and offline workflows, allowing engineers to continue working in environments without internet connectivity.

The platform consists of a cross-platform desktop application used by engineers in the field, along with a web-based administration system used to manage report templates and submit finalized reports to clients. The architecture separates form definitions and report structures from application code, allowing report formats to evolve without requiring application updates or redeployments.`,

            development: `I was solely responsible for the design and development of the SMARTS ReportBuilder desktop application and its embedded local database used for offline operation. The application dynamically generates forms and reports based on configurable templates retrieved through APIs and stored locally within the application database.

I also developed a web administration interface used by administrators to manage report templates and submit finalized reports to clients. I collaborated with backend engineers responsible for the API layer and central server database while owning the desktop client, web interface, and local database integration.

This architecture allows engineers to generate reports entirely offline while still supporting synchronization and centralized management of report templates.`,

            prototyping: `During early development, I explored multiple approaches for implementing dynamic form generation and template-driven reporting. The goal was to design a system where report structures could evolve without requiring application updates.

I implemented a template-driven architecture where form definitions and report structures are retrieved through APIs and stored locally, allowing the application to dynamically generate forms and reports based on configuration rather than static UI code. This approach increased system flexibility and reduced the need for code changes when report formats changed.`,

            challenges: `One of the main challenges was designing an offline-first architecture that allowed engineers to generate reports without internet access while still maintaining synchronization with centrally managed report templates.

This required building a reliable local database layer embedded within the desktop application to store templates, configuration, and generated report data. Another challenge was designing the template-driven reporting engine so that complex forms and reports could be generated dynamically without introducing excessive complexity into the application logic.

Ensuring that templates could evolve without breaking existing reports required careful data modeling and a clear separation between configuration and application code.`,
        },

        url: null,
    },

    {
        id: 'smarts-central',
        type: 'Internal Web Administration Platform',
        images: {
            overview: Central_1,
            development: Central_2,
            prototyping: Central_3,
            challenges: Central_5,
        },
        altText:
            'SMARTS Central web application used to review, process, and administer engineering inspection reports.',
        title: 'SMARTS Central',
        role: 'Full-Stack Development',
        stack: 'React / TypeScript / ASP.NET Core / REST APIs / SQL Server',
        overview:
            'Internal web administration platform used to review, process, monitor, and manage engineering inspection reports before they are delivered to clients. The system provides workflow management, recommendation administration, logging, role-based access, and operational visibility across the reporting lifecycle.',

        details: {
            overview: `SMARTS Central is an internal web platform built to support the administrative side of the engineering reporting workflow. While field engineers use SMARTS ReportBuilder to complete inspections and generate reports, SMARTS Central is used by administrators and reviewers to process submitted surveys, manage recommendations, monitor report status, and oversee the delivery pipeline before reports are sent to clients.

The system acts as the centralized operational layer of the SMARTS ecosystem, giving internal teams visibility into report progress, workload status, review state, logging, and administrative controls. It was designed to support data-heavy workflows, internal coordination, and structured processing across multiple stages of the reporting lifecycle.`,

            development: `I developed SMARTS Central as a React and ASP.NET Core web application used to administer inspection engineering reports before delivery to clients. The platform includes workflow dashboards, recommendation management, log inspection screens, survey processing views, and administrative role management.

The application supports operational workflows such as reviewing survey submissions, tracking status changes, identifying issues through logs, and managing structured recommendation data tied to reports. I focused on building maintainable data-heavy interfaces, integrating them with backend APIs, and supporting internal users who need clear visibility and control over report processing.`,

            prototyping: `During development, I focused on designing interfaces that could support large datasets, repeated operational actions, and quick navigation between workflow states. This included experimenting with dense table layouts, filter and view controls, status indicators, and screen organization so administrators could move efficiently between surveys, logs, recommendations, and employee management.

Because the platform is used as an internal administration tool, usability depended less on marketing-style presentation and more on operational speed, clarity, and consistency. I structured the UI around high-frequency actions such as review, processing, filtering, monitoring, and issue investigation.`,

            challenges: `One of the main challenges was designing a web interface capable of handling complex administrative workflows without overwhelming the user. The platform needed to present large amounts of report data, workflow metadata, statuses, and recommendation details while still allowing administrators to quickly identify what required action.

Another challenge was building screens that served different operational purposes within one system, including survey queues, recommendation management, system logs, and employee permissions. This required careful attention to data organization, reusable UI patterns, and clear separation between operational views.

Supporting internal users also meant prioritizing reliability and visibility. Features such as logs, workflow statuses, filtering, and monitoring were important because administrators needed to understand where reports were in the pipeline and quickly troubleshoot problems when something failed or became blocked.`,
        },

        url: null,
    },

    {
        id: 'grc-connect-ai-assistant',
        type: 'AI Data Assistant (Enterprise Data Query Interface)',
        images: {
            overview: Connect_ai_1,
            development: Connect_ai_5,
            prototyping: Connect_ai_4,
            challenges: null,
        },
        altText:
            'AI assistant integrated into GRC Connect allowing users to query risk engineering data using natural language.',
        title: 'GRC Connect AI Assistant',
        role: 'Frontend Development / AI Integration',
        stack: 'React / TypeScript / Azure OpenAI / ASP.NET Core / SQL Server',
        overview:
            'AI-powered assistant integrated into the GRC Connect platform that enables users to query enterprise risk engineering data using natural language. The assistant translates user prompts into structured queries executed through secure backend APIs and returns operational data such as inspection status, recommendations, and facility information.',

        details: {
            overview: `The GRC Connect AI Assistant was built to simplify how users interact with complex risk engineering data stored across internal systems. Instead of navigating multiple dashboards and filters, users can ask natural language questions and receive structured responses derived from enterprise datasets.

The assistant is embedded directly within the GRC Connect platform and provides answers related to inspections, recommendations, impairments, facilities, and risk ratings. Responses may include summarized explanations or structured data tables depending on the type of query.`,

            development: `I contributed to the frontend development and system integration of the AI assistant within the GRC Connect platform. The assistant interface was designed as a conversational panel embedded within the application, allowing users to interact with enterprise data in a chat-based format.

The system uses Azure OpenAI to interpret user prompts and generate structured queries executed through secure ASP.NET APIs connected to on-premise enterprise databases. Query results are then returned to the interface and rendered either as conversational responses or structured data tables.`,

            prototyping: `During development, the focus was on designing an interface that could support both conversational interaction and structured operational data. Many enterprise queries return large datasets, so the assistant needed to present tabular outputs clearly while still maintaining a conversational flow.

The interface supports follow-up questions, quick suggestion prompts, and direct links to relevant dashboards within the GRC Connect platform so users can move seamlessly between AI-driven insights and existing system tools.`,

            challenges: `A key challenge was integrating AI-driven query capabilities within an enterprise environment where sensitive operational data must remain secure. The system needed to allow flexible natural language interaction while ensuring that queries were translated into controlled, structured database operations.

Another challenge was designing a response system that could handle both conversational answers and structured datasets. Many queries required returning large tables of inspection records, recommendations, or facility information, so the interface had to balance readability with operational usefulness.`,
        },

        url: null,
    },

    {
        id: 'gripss-platform',
        type: 'Enterprise Inspection Management Platform',
        images: {
            overview: Gripss_1,
            development: Gripss_3,
            prototyping: Gripss_2,
            challenges: null,
        },
        altText:
            'GRIPSS enterprise platform used to manage engineering inspections, schedules, and operational data.',
        title: 'GRIPSS Inspection Management Platform',
        role: 'Frontend Development / System Integration',
        stack: 'React / TypeScript / ASP.NET Core / SQL Server / REST APIs',
        overview:
            'Internal enterprise platform used by engineering teams to manage inspections, operational workflows, and inspection records across global facilities. The system provides advanced data management tools including filtering, dynamic views, editing interfaces, and reporting capabilities.',

        details: {
            overview: `GRIPSS is an internal platform used by engineering teams to manage inspection records and operational workflows across multiple clients and global facilities. The system centralizes inspection scheduling, completion tracking, and reporting data into a single interface used by internal teams.

The platform supports large datasets containing inspection records, client locations, inspection statuses, and operational metadata. Engineers and administrators use the system to review inspection data, update records, and monitor operational activity across multiple regions.`,

            development: `I contributed to the development of the GRIPSS frontend platform using React and TypeScript. The application provides data management tools that allow users to view, filter, and edit large sets of inspection records in real time.

The system includes advanced table functionality with dynamic filtering, customizable column views, export tools, and detailed editing dialogs used to modify inspection records. The platform integrates with backend APIs built with ASP.NET Core that retrieve and update inspection data stored in enterprise SQL Server databases.`,

            prototyping: `During development, the focus was on designing a user interface capable of handling large operational datasets while maintaining usability and performance. The platform includes configurable table views, search tools, filtering capabilities, and responsive layouts that allow users to quickly locate and manage inspection records.

The interface was designed to support both light and dark modes and provide efficient workflows for reviewing inspection records and updating operational data.`,

            challenges: `One of the main challenges was building a data management interface capable of handling large inspection datasets while maintaining responsive performance and clear user workflows.

This required implementing optimized table rendering, efficient filtering logic, and structured editing interfaces that allow users to modify inspection data without disrupting ongoing workflows. Another challenge was ensuring the interface remained intuitive despite the complexity of the operational data being managed.`,
        },

        url: null,
    },

    {
        id: 'grc-impairment-notification-system',
        type: 'Legacy Frontend Modernization',
        images: {
            overview: Eda_1,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'GRC Fire Protection Impairment Notification System frontend interface.',
        title: 'Fire Protection Impairment Notification System',
        role: 'Frontend Modernization / UI Styling',
        stack: 'HTML / CSS / JavaScript',
        overview:
            'Legacy internal web application used to report and manage fire protection impairments. I contributed frontend styling improvements to modernize the interface, improve visual consistency, and create a cleaner user experience while working within an existing production system.',

        details: {
            overview: `The Fire Protection Impairment Notification System is an internal web application used to report and manage fire protection impairments. The system allows users to create accounts, report impairments, update or cancel existing entries, and review impairment history through a structured workflow.`,

            development: `My contribution focused on updating the frontend styling and improving the visual presentation of the application. I refreshed the CSS to create a cleaner and more modern interface while preserving the existing functionality and working within the constraints of a live production system.`,

            prototyping: `The work centered on improving usability and presentation rather than rebuilding the application architecture. The goal was to make the interface feel more polished, consistent, and easier to navigate without disrupting the existing workflow used by internal users.`,

            challenges: `One of the main challenges was modernizing the visual layer of an existing system without changing core functionality or introducing regressions. This required working within the constraints of an older application structure while improving spacing, hierarchy, readability, and overall interface consistency.`,
        },

        url: null,
    },

    {
        id: 'nlm-dreamanatomy',
        type: 'website',
        images: {
            overview: NlmDreamAnatomy,
            development: null,
            prototyping: NlmDreamAnatomy_Prototype,
            challenges: null,
        },
        altText:
            'An image of the National Library of Medicine - Dream Anatomy Exhibition.',
        title: 'National Library of Medicine - Dream Anatomy',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview:
            "Produced, designed and developed by Astriata. I was responsible for Front-End development of the National Library of Medicine exhibition, as part of Astriata's team",
        details: {
            overview: `The National Library of Medicine - Exhibition Program was created with the goal of producing online exhibitions that stimulate enthusiasm for history and encourage people to learn about medicine, themselves, and their communities.

      Drawn mainly from the collections of the National Library of Medicine, Dream Anatomy shows off the anatomical imagination of the human body made possible by the printing press, from 1500 to the present.
      `,
            development: `The Dream Anatomy exhibition was designed by Astriata's design team and developed by myself as Astriata's Front-End Developer. The Website features multiple sections with each containing sub-sections that contain assets. The user can horizontally navigate through these assets using the mouse wheel, arrow keys, the tab key or through a custom built scroll bar at the bottom of the exhibition. The scroll bar contains bullets which represents the start of sub-sections in each section. I used Swiper package to horizontally navigate between assets in each section. Built-in Intersection Observer API to trigger multiple functionalities such as section transitions and lazy-loading images in assets. The Exhibition follows best accessibility practices and is compatible with screen readers. It was created using Vanilla JavaScript, HTML, and Sass.`,
            prototyping: `During the prototyping phase, I tested multiple packages to see which would be most suitable with the project's navigation requirements. One of them was the GSAP package which I used to build the prototype. After building the prototype, I decided that Swiper would be a better choice since its core features revolved around sliders and slider functionalities, like events that gets triggered when a slider is at the start or end, or dynamically generating slides in sections, which was useful since the layout of the exhibition changed on tablet and mobile screens. All of these Swiper features and ease of use made it the better choice. `,
            challenges: `Navigation between sections and assets in different sections was definitely one of the challenges I faced during development, either it be through thumbnails in the gallery section (last section of the exhibition) or through unique URL parameters. Scrolling to a section and then triggering an event to swiper to scroll to the target asset in that section, was my go to solution to tackle this challenge. Exhibition loading speed was also definitely a concern since the website had a lot of content. Lazy-loading images as well as dynamically generating assets and thumbnails asynchronously, was the best solution in my opinion to improve the page loading speed. Another challenge and to which Alex (Astriata's Backend Developer) helped me tackle, was the logic to dynamically position the scrollbar bullets in relation to the position of their corresponding sub-sections, in each section.`,
        },
        url: 'https://www.nlm.nih.gov/exhibition/dream-anatomy/index.html',
    },

    {
        id: 'aahhrpp',
        type: 'website',
        images: {
            overview: Aahrpp,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of the The Association for the Accreditation of Human Research Protection Programs, Inc website.',
        title: 'AAHRPP',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview:
            "Produced, designed and developed by Astriata. I was responsible for Front-End development for the Association for the Accreditation of Human Research Protection Programs, Inc. website, as part of Astriata's team.",
        details: {
            overview: `The Association for the Accreditation of Human Research Protection Programs, Inc. (AAHRPP) promotes high-quality research through an accreditation process that helps organizations worldwide strengthen their human research protection programs (HRPPs).
      `,
            development: `The AAHRPP website was designed by Astriata's design team. Front-End development was done by myself as Astriata's Front-End Developer, and CMS integration using Sitefinity was done by Alex as Astriata's Back-End Developer. The website features over 30 pages with 100+ users a day. As Astriata's development team, me and Alex worked together to produce the best product for the client, while tackling bugs, QA tasks, and new feature requests by the client along the development phase. The website follows best SEO and accessibility practices and is compatible with screen readers.
      `,
            prototyping: ``,
            challenges: ``,
        },
        url: 'https://aahrpp.org/',
    },

    {
        id: 'nceed',
        type: 'web-application',
        images: {
            overview: Nceed,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            "An image of the National Center of Excellence for Eating Disorders' web application for Screening, Brief Intervention, and Referral to Treatment for Eating Disorders.",
        title: 'NCEED - SBIRT-ED',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview:
            "Produced, designed and developed by Astriata. I was responsible for Front-End development for the National Center of Excellence for Eating Disorders web application, as part of Astriata's team.",
        details: {
            overview: `The National Center of Excellence for Eating Disorders is one of the nation’s first center of excellence, dedicated to eating disorders. The SBIRT-ED web-application, which stands for Screening, Brief Intervention, and Referral to Treatment for Eating Disorders, is an easy-to-access tool for primary care providers, which provides real-time risk level results for patients to help them screen for eating disorders.
      `,
            development: `The SBIRT-ED web-application was designed by Astriata's design team I was responsible for its Front-End development. The web-application consisted of multiple forms, which depending on the user's input, would take them to a different form until they finish the screening and the result is displayed on the screen. The web-application follows best SEO and accessibility practices and is compatible with screen readers.
      `,
            prototyping: ``,
            challenges: ``,
        },
        url: 'https://eatingdisorderscreener.org/',
    },

    {
        id: 'bankit-app',
        type: 'Web-Application',
        images: {
            overview: BankitApp,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Bankit App Web-Application . A website that advertises the Bankit App.',
        title: 'Bankit App',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview: 'Landing page that advertises the Bankit App',
        details: {
            overview: `A Web Application where users can track their deposits, withdrawals, request loans, transfer money and even delete their accounts.`,
            development: `This App utilizes a lot of Modern ES6+ Array methods and tools inorder to manipulate multiple users account data. Some of the methods used to manipulate these Data Structures include destructuring, Spread and Rest operators, map(), filter() and reduce() methods, Nullish (??) and Optional Chaining (?.) operators, Short-Circuiting operators (&& and ||), and much more.`,
            prototyping: null,
            challenges: null,
        },
        url: `http://bankitapp.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Bankit-App`,
    },

    {
        id: 'kardio-dev',
        type: 'Web-Application',
        images: {
            overview: KardioDev,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Kardio-Dev Web Application. A workout tracker Application.',
        title: 'Kardio Dev',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview: 'A Workout Tracker Web Application',
        details: {
            overview: `A Fully Responsive Workout Tracker Web Application that uses multiple APIs in order to track and locally save the User's workouts Input Data. APIs used in this App include a Geolocation API which pinpoints the user's workout location, and a Local Storage API which saves the user's workout input data to the browser's Local Storage. 
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://kardiodev.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Kardio-Dev-App`,
    },

    {
        id: 'fresco',
        type: 'web-application',
        images: {
            overview: Fresco,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText: 'An image of the Fresco Web-Application. A food ordering app.',
        title: 'Fresco',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript ',
        overview: 'A food ordering web-application created with ReactJS',
        details: {
            overview: `A food ordering app where users can order food from a provided menu. The menu is fetched from a database. Upon order confirmation, the order is sent to a different database to be processed 🍜. This app utilizes the ReactJS built in ContextAPI to manage and update the app-wide state which controls the cart's functionality.`,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://fresco.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/react-food-order-app`,
    },

    {
        id: 'country-stats',
        type: 'Web-Application',
        images: {
            overview: CountryStats,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Country Stats Web Application. A Fully Responsive Web Application that displays information about countries.',
        title: 'Country Stats',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview:
            'A Web Application that displays information about countries and their neighbors.',
        details: {
            overview: `A Fully Responsive Web Application that displays information about countries and their neighbors, depending on user's input.
      `,
            development: `This simple Web Application utilizes Promises, Fetch API, and Async/Await to create and chain multiple AJAX Calls in order to fetch the client's requested data Asynchronously from a Third-Party API. Response data is then used to render information about the specified country and its neighbors.`,
            prototyping: null,
            challenges: null,
        },
        url: `http://countrystats.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Country_Stats`,
    },

    {
        id: 'wallee',
        type: 'web-application',
        images: {
            overview: Wallee,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of the Expensio Web-Application. An expense tracker app.',
        title: 'Wallee',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript ',
        overview: 'An expense tracker web application built with ReactJS.',
        details: {
            overview: `An expense tracker web application where users can add, delete, and sort their monthly expenses.`,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://wallee.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/react-expense-tracker-app/tree/main/react-expense-tracker`,
    },

    {
        id: 'bankit-website',
        type: 'website',
        images: {
            overview: BankitWeb,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Bankit. A website that advertises the Bankit App.',
        title: 'Bankit Website',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview: 'Landing page that advertises the Bankit App',
        details: {
            overview: `A Fully Responsive landing page that advertises the Bankit App. Where users can explore all the App's features and services, and even sign-up an account to the Bankit Web Application.. 
      `,
            development: `This landing page features multiple DOM Manipulation and DOM Traversing techniques through Capturing and Bubbling, by using the Event Delegation event handling pattern. Featured techniques include smooth scrolling and hover animations to child elements through their parent element, lazy loading images, content reveal on scroll through the Intersection Observer API, a tab and slider components along with multiple other techniques that brings the page to life.`,
            prototyping: null,
            challenges: null,
        },
        url: `http://bankit.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Bankit-Website`,
    },

    {
        id: 'guess-number-game',
        type: 'Web-Application',
        images: {
            overview: GuessNumber,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText: 'An image of the Guess the Number Game Web Application.',
        title: 'Guess the Number Game',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview: 'Guess the correct number to win 🎉',
        details: {
            overview: `A Game where players tries to guess a randomly generated number to win, and then attempt to beat their current high score by guessing the number in the least amount of rounds. PS. Check Console 😉.
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://guessthenumber.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Guess-the-Number-Game`,
    },

    {
        id: 'pig-game',
        type: 'Web-Application',
        images: {
            overview: PigGame,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText: 'An image of the Pig game Web Application.',
        title: 'Pig Game',
        role: 'Development',
        stack: 'HTML / CSS / JavaScript',
        overview: 'A dice game 🎲',
        details: {
            overview: `A game where players take turns to roll a single die as many times as they wish, adding all roll results to a running total, but losing their gained score for the turn if they roll a 1. First to collect 100 points wins 🥇.
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://piggame.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/The-Pig-Game`,
    },

    {
        id: 'nexter-website',
        type: 'website',
        images: {
            overview: NexterHomes,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Nexter Website. Luxury real estate marketplace website. Where users can find their dream home. 🏡',
        title: 'Nexter',
        role: 'Development',
        stack: 'HTML / CSS',
        overview: 'A website that utilizes CSS Grid Layout',
        details: {
            overview: `A Fully Responsive luxury real estate marketplace website. Where users can find their dream home 🏡. This landing page was built completely using CSS Grid Layouts inorder to tackle some of the most advanced CSS Grid Layout techniques. 
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://nexter.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Nexter`,
    },

    {
        id: 'tour-website',
        type: 'website',
        images: {
            overview: Tours,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Tours Website. A website that advertises a Touring Agency.',
        title: 'Tours',
        role: 'Development',
        stack: 'HTML / CSS',
        overview: 'A website that advertises a Touring Agency',
        details: {
            overview: `A website that advertises a Tour Agency, that was built using HTML, CSS, SCSS with implementation of BEM and SMACCS methodologies.
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://tour.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/tour_website`,
    },

    {
        id: 'fenko-website',
        type: 'website',
        images: {
            overview: FenkoHotel,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText: 'An image of Fenko Website. An All-in one booking App.',
        title: 'Fenko',
        role: 'Development',
        stack: 'HTML / CSS',
        overview: 'A website that utilizes CSS FlexBox Techniques',
        details: {
            overview: `An All-in one booking App where users can book a Hotel, a flight, a car, and a tour, all from one platform 🌅. This landing was build completely using CSS Flex-Box and practices some of the most modern responsive techniques using FlexBox.
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://fenko.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Fenko`,
    },

    {
        id: 'freelance',
        type: 'Website',
        images: {
            overview: Freelance,
            development: null,
            prototyping: null,
            challenges: null,
        },
        altText:
            'An image of Freelance Website. A Fully Responsive Website that advertises different services being offered by the great Mikel Kamel.',
        title: 'Freelance',
        role: 'Development',
        stack: 'HTML / CSS ',
        overview: 'Freelancing website created by the great Mikel Kamel.',
        details: {
            overview: `One of my first ever Websites. It was created specifically for freelancing which advertises the different services is used to offer back in the day.
      `,
            development: null,
            prototyping: null,
            challenges: null,
        },
        url: `http://freelance.mikelkamel.com/`,
        github: `https://github.com/BigMikeL9/Freelance-Website`,
    },
]

export default worksData
